export default {"src":"/_next/static/media/0xe9e7cea3dedca5984780bafc599bd69add087d56.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};